import { Injectable, WritableSignal } from '@angular/core';
import { UserResponseDTO } from '@app/modules/user/interfaces/user-response-dto.interface';
import { SignalHandler } from '@services/signal-handler.service';

import { authConfig } from '../config';

@Injectable({
  providedIn: 'root',
})
export class AuthUserAuthenticatedSignalHandler extends SignalHandler<UserResponseDTO> {
  private readonly userSection =
    authConfig.actions.userAuthentication.sections.authUser;

  public getUserAuthenticated(): WritableSignal<UserResponseDTO> {
    return this.getDataSignal(this.userSection);
  }

  public getUserAuthenticatedId(): number {
    return this.getDataSignal(this.userSection)().id;
  }

  public setUserAuthenticated(user: UserResponseDTO): void {
    this.replaceDataSignal(this.userSection, user);
  }

  public updateUserAuthenticated(user: UserResponseDTO): void {
    const userUpdated = {
      ...this.getDataSignal(this.userSection)(),
      ...user,
    };
    this.replaceDataSignal(this.userSection, userUpdated);
  }

  public cleanUser(): void {
    this.cleanSection(this.userSection);
  }
}
